(function (angular) {
    angular
        .module('app.purchase')
        .controller('app.purchase.ApplicantInfoController', [
            '$scope',
            '$state',
            'states',
            'relationships',
            'purchase',
            'app.purchase.purchaseFlowService',
            'ui',
            '$uibModal',
            '$rootScope',
            controller
        ]);

    function controller(
        $scope,
        $state,
        states,
        associationRelationship,
        purchase,
        purchaseFlowService,
        ui,
        $uibModal,
        $rootScope
    ) {
        var vm = this;

        vm.siteContent = siteContent;
        vm.purchase = purchase;
        vm.plan = purchase.plan;
        vm.primaryApplicant = purchase.primaryApplicant;
        vm.existingAssociateMembers = purchase.associatedApplicants || [];
        vm.currentState = $rootScope.currentState;

        vm.states = states;
        vm.associationRelationship = associationRelationship;
        vm.showToolTip = false;
        vm.responsiblePartyConfirmPassword = '';
        vm.primaryConfirmPassword = '';
        vm.calculateAge = calculateAge;
        vm.isMinor = isMinor;
        vm.updateSalesTax = updateSalesTax;
        vm.allMemberMinors = allMemberMinors;
        vm.finishInformation = finishInformation;
        vm.collectResponsiblePartyInfo = false;
        vm.collectPrimaryInformation = false;
        vm.passwordPattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$';
        vm.hidePassword = true;
        vm.hideConfirmPassword = true;
        vm.userInfo = {};
        $scope.emailSpinner = false;

        var primarApp = null;
        if (vm.primaryApplicant) {
            primarApp = JSON.parse(JSON.stringify(vm.primaryApplicant));
        }

        vm.primaryApplicant = {
            firstName: '',
            lastName: '',
            birthDate: '',
            addressline1: '',
            addressLine2: '',
            city: '',
            state: '',
            zipCode: '',
            employerName: '',
            emailAddress: '',
            phoneNumber: '',
            password: ''
        };

        if (!vm.associatedApplicants) {
            vm.associatedApplicants = [];
            if (primarApp === null) {
                vm.associatedApplicants.push(newMember(true));
            } else {
                if (primarApp.birthDate) {
                    primarApp.birthDate = getFormattedDate(new Date(primarApp.birthDate));
                }

                vm.associatedApplicants.push(primarApp);
            }

            if (vm.purchase.minNumberMembers > 1) {
                for (let index = 0; index < vm.existingAssociateMembers.length; index++) {
                    if (vm.existingAssociateMembers[index] && vm.existingAssociateMembers[index].birthDate) {
                        vm.existingAssociateMembers[index].birthDate = getFormattedDate(
                            new Date(vm.existingAssociateMembers[index].birthDate)
                        );
                    }

                    vm.existingAssociateMembers[index].show = true;
                    vm.associatedApplicants.push(vm.existingAssociateMembers[index]);
                }

                while (vm.associatedApplicants.length < vm.purchase.minNumberMembers) {
                    vm.associatedApplicants.push(newMember(true));
                }
            } // do nothing if it's an individual plan
        } else if (primarApp !== null) {
            vm.associatedApplicants.unshift(primarApp);
        }

        vm.responsibleParty = null;

        $scope.$watch(
            function (scope) {
                return scope.vm.primaryApplicant;
            },
            function () {
                if (!$scope.emailSpinner) {
                    //purchaseFlowService.updatePrimaryApplicantInfo(vm.primaryApplicant, $scope.applicantForm.emailAddress.$invalid);
                }
            },
            true
        );

        $scope.$watch(
            function (scope) {
                return scope.vm.associatedApplicants;
            },
            function () {
                //purchaseFlowService.updateAssociateMemberInfo(vm.associatedApplicants);
            },
            true
        );

        // functions
        vm.addMember = addMember;
        vm.removeMember = removeMember;
        vm.responsiblePartyNoMatch = responsiblePartyNoMatch;
        vm.primaryNoMatch = primaryNoMatch;
        vm.continueToPayment = continueToPayment;
        vm.selectPrimary = selectPrimary;
        vm.goBack = goBack;
        vm.triggerPrivacyPolicyModal = showPrivacyPolicyModal;
        vm.primaryApplicantSelected = primaryApplicantSelected;
        vm.allAssociatedApplicantsAdults = allAssociatedApplicantsAdults;
        vm.showTermsOfUseModal = showTermsOfUseModal;
        vm.checkState = checkState;
        vm.adults = [];

        function goBack() {
            vm.collectPrimaryInformation = false;
            vm.collectResponsiblePartyInfo = false;
            vm.responsibleParty = null;

            var primarApp = null;
            if (vm.primaryApplicant) {
                primarApp = JSON.parse(JSON.stringify(vm.primaryApplicant));
                primarApp.authorized = false;
            }

            vm.primaryApplicant = {
                firstName: '',
                lastName: '',
                birthDate: '',
                addressline1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipCode: '',
                employerName: '',
                emailAddress: '',
                phoneNumber: '',
                password: ''
            };
        }

        vm.togglePassword = function () {
            vm.hidePassword = !vm.hidePassword;
        };

        vm.toggleConfirmPassword = function () {
            vm.hideConfirmPassword = !vm.hideConfirmPassword;
        };

        function showPrivacyPolicyModal() {
            $uibModal.open({
                templateUrl:
                    vm.siteContent.site.purchaseFlow.activatePlan.privacyPolicyTemplate &&
                    vm.siteContent.site.purchaseFlow.activatePlan.privacyPolicyTemplate.path
                        ? vm.siteContent.site.purchaseFlow.activatePlan.privacyPolicyTemplate.path
                        : '/app/site/purchase-flow/activate-plan/modals/privacy-policy.modal.html',
                keyboard: true,
                windowTopClass: 'patolus-modal-backdrop',
                controller: 'app.purchase.privacyPolicyModalController',
                controllerAs: 'vm'
            });
        }

        function showTermsOfUseModal() {
            $uibModal.open({
                templateUrl:
                    vm.siteContent.site.purchaseFlow.activatePlan.touLink &&
                    vm.siteContent.site.purchaseFlow.activatePlan.touLink.path
                        ? vm.siteContent.site.purchaseFlow.activatePlan.touLink.path
                        : '/app/site/purchase-flow/activate-plan/modals/terms-of-use.modal.html',
                keyboard: true,
                windowTopClass: 'patolus-modal-backdrop',
                controller: 'app.purchase.termsOfUseModalController',
                controllerAs: 'vm'
            });
        }

        function showStateVerificationModal() {
            $uibModal
                .open({
                    templateUrl:
                        '/app/site/purchase-flow/applicant-info/modal/state-verification-modal/state-verification-modal.html',
                    keyboard: true,
                    windowTopClass: 'patolus-modal-backdrop',
                    controller: 'app.purchase.stateVerificationModalController',
                    controllerAs: 'vm'
                })
                .result.then(function fulfilled(result) {
                    if (result === true) {
                        $rootScope.isOpenLocationModal = true;
                    }
                });
        }

        function checkState() {
            if (!siteContent.isSGDPP && vm.primaryApplicant.state != $rootScope.currentState) {
                showStateVerificationModal();
            }
        }

        function getFormattedDate(date) {
            var year = date.getFullYear();

            var month = (1 + date.getMonth()).toString();
            month = month.length > 1 ? month : '0' + month;

            var day = date.getDate().toString();
            day = day.length > 1 ? day : '0' + day;

            return month + '/' + day + '/' + year;
        }

        function selectPrimary(adult) {
            if (vm.primaryApplicant.authorized) {
                vm.primaryApplicant.authorized = false;
            }

            if (vm.primaryApplicant.isResponsibleParty) {
                vm.primaryApplicant.isResponsibleParty = false;
            }

            vm.primaryApplicant = adult;

            if (!allAssociatedApplicantsAdults()) {
                vm.primaryApplicant.isResponsibleParty = true;
            }
        }

        function scrollToTop() {
            if (window.scrollY != 0) {
                setTimeout(function () {
                    window.scrollTo(0, window.scrollY - 30);
                }, 5);
            }
        }

        function allAssociatedApplicantsAdults() {
            for (let index = 0; index < vm.associatedApplicants.length; index++) {
                var associate = vm.associatedApplicants[index];
                if (isMinor(associate.birthDate)) {
                    return false;
                }
            }

            return true;
        }

        function allMemberMinors() {
            if (
                !vm.associatedApplicants ||
                vm.associatedApplicants.length == 0 ||
                !vm.associatedApplicants[0].birthDate ||
                vm.associatedApplicants[0].birthDate === null ||
                vm.associatedApplicants[0].birthDate === ''
            ) {
                return false;
            }

            if (
                vm.primaryApplicant &&
                vm.primaryApplicant.birthDate &&
                vm.primaryApplicant.birthDate !== null &&
                vm.primaryApplicant.birthDate !== '' &&
                !isMinor(vm.primaryApplicant.birthDate)
            ) {
                return false;
            }

            for (let index = 0; index < vm.associatedApplicants.length; index++) {
                var associate = vm.associatedApplicants[index];
                if (!isMinor(associate.birthDate)) {
                    return false;
                }
            }

            return true;
        }

        function isMinor(dob) {
            return calculateAge(dob) < 18;
        }

        function calculateAge(dob) {
            if (!(dob instanceof Date)) {
                if (!dob || dob === null || dob === '') {
                    return 0;
                }

                dob = new Date(dob);
            }

            var ageDifMs = Date.now() - dob.getTime();
            var ageDate = new Date(ageDifMs); // miliseconds from epoch
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        }

        //Check that both passwords match
        function responsiblePartyNoMatch() {
            return !(vm.responsibleParty.password === vm.responsiblePartyConfirmPassword);
        }

        function primaryNoMatch() {
            return !(vm.primaryApplicant.password === vm.primaryConfirmPassword);
        }

        function finishInformation() {
            if (allMemberMinors()) {
                finishInformationFinal();
                return;
            }
            ui.block();
            vm.userInfo = purchaseFlowService
                .getUser(vm.associatedApplicants[0].emailAddress)
                .then(function () {})
                .finally(function () {
                    ui.unblock();
                    var currentUserInfo = purchaseFlowService.getUserInfo();
                    if (currentUserInfo == undefined || currentUserInfo == '') {
                        finishInformationFinal();
                    } else {
                        showSignInModal();
                        return;
                    }
                });
        }

        function finishInformationFinal() {
            if (allMemberMinors()) {
                vm.primaryApplicant = JSON.parse(JSON.stringify(vm.associatedApplicants[0]));
                vm.associatedApplicants.splice(0, 1);

                vm.responsibleParty = {
                    firstName: '',
                    lastName: '',
                    birthDate: '',
                    addressline1: '',
                    addressLine2: '',
                    city: '',
                    state: '',
                    zipCode: '',
                    employerName: '',
                    emailAddress: '',
                    phoneNumber: '',
                    password: ''
                };

                vm.collectResponsiblePartyInfo = true;
                scrollToTop();
            } else {
                vm.adults = [];
                for (let index = 0; index < vm.associatedApplicants.length; index++) {
                    var member = vm.associatedApplicants[index];
                    if (!isMinor(member.birthDate)) {
                        vm.adults.push(member);
                    }
                }

                vm.primaryApplicant = vm.adults[0];
                vm.primaryApplicant.isResponsibleParty = true;
                vm.collectPrimaryInformation = true;
            }
        }

        function primaryApplicantSelected() {
            var index = vm.associatedApplicants.indexOf(vm.primaryApplicant);
            vm.associatedApplicants.splice(index, 1);

            continueToPayment();
        }

        function continueToPayment() {
            purchaseFlowService.getSalesTax(vm.primaryApplicant.zipCode);
            ui.block();
            purchaseFlowService
                .updatePrimaryApplicantInfo({
                    primaryApplicant: vm.primaryApplicant,
                    associatedApplicants: vm.associatedApplicants,
                    responsibleParty: vm.responsibleParty
                })
                .then(function () {
                    if (vm.siteContent.isSGDPP) {
                        $state.go('app.sgdpppurchase.payment');
                    } else {
                        $state.go('app.purchase.payment');
                    }
                })
                .finally(function () {
                    ui.unblock();
                });
        }

        function newMember(shouldShow) {
            return {
                firstName: '',
                lastName: '',
                birthDate: '',
                relationship: '',
                emailAddress: '',
                phoneNumber: '',
                show: shouldShow
            };
        }

        function addMember() {
            var newestMember = newMember(false);
            newestMember.show = true;
            vm.associatedApplicants.push(newestMember);
        }

        function removeMember(index) {
            var removedMember = vm.associatedApplicants[index];
            removedMember.show = false;

            setTimeout(function () {
                vm.associatedApplicants.splice(index, 1);
            }, 100);
        }

        function showSignInModal() {
            $uibModal
                .open({
                    templateUrl: '/app/site/purchase-flow/applicant-info/modal/sign-in/sign-in.html',
                    keyboard: true,
                    windowTopClass: 'patolus-modal-backdrop',
                    controller: 'app.purchase.signInController',
                    controllerAs: 'vm'
                })
                .result.then(function fulfilled(result) {
                    // if (result === true) {
                    //     $rootScope.isOpenLocationModal = true;
                    // }
                });
        }

        function updateSalesTax(event) {
            console.log(vm.purchase);
            if (event.target.value) {
                purchaseFlowService.getSalesTax(event.target.value).then(function(response) {
                    vm.purchase = response.data;
                }).catch(function(error) {
                    console.error('Error fetching sales tax:', error);
                });
            }
        }

        function generateOtp() {}

        function authenticateOtp() {}

        $scope.WAStateModalCheck = function (type) {
            if (type == 1) {
                if (vm.primaryApplicant.state === 'WA') {
                    var activeModal = $uibModal.open({
                        templateUrl: '/app/site/purchase-flow/applicant-info/wa-state-modal/wa-state-modal.html',
                        controller: 'app.purchase.waStateModalController',
                        controllerAs: 'vm',
                        keyboard: true
                    });
                }
            } else if (type == 2) {
                if (vm.responsibleParty.state === 'WA') {
                    var activeModal = $uibModal.open({
                        templateUrl: '/app/site/purchase-flow/applicant-info/wa-state-modal/wa-state-modal.html',
                        controller: 'app.purchase.waStateModalController',
                        controllerAs: 'vm',
                        keyboard: true
                    });
                }
            }
        };
    }
})(angular);
